export default "__VITE_ASSET__DZ6S$fDc__"